import FailedDistributionsReportModal from "./FailedDistributionsReportModal"

export default FailedDistributionsReportModal
